<template>
  <div class="xm-video">
    <div class="video-modal">
      <video
        :src="newVideoSrc"
        class="video"
        id="video"
        ref="modalVideo"
        :onCanPlayThrough="playModalVideo()"
        x5-video-player-type='h5'
        x5-video-player-fullscreen='true'
        playsInline
        webkit-playsinline="true" 
        controls="controls"
        preload="auto"
      ></video>
      <img @click="closeVideo" class="video-close" src="https://image.xiaomaiketang.com/xm/W4P582NReT.png" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "xm-video-modal",
  props: {},
  components: {
    //Example
  },

  data() {
    return {
      newVideoSrc: this.$route.query.url,
      modalBg: false,
      videoModalShow: false
    };
  },

  methods: {
    playModalVideo() {},

    closeVideo() {
      this.$router.back();
    }
  },

  mounted() {
    // 有下载视频按钮时去掉自动播放功能，不然安卓端显示不了下载视频按钮
    setTimeout(() => {
      document.getElementById("video").play();
      wx.getNetworkType({
        success: function(res) {
          document.getElementById("video").play();
        }
      });
    }, 100);
  },
};
</script>

<style lang='less'>
.xm-video {
  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(0, 0, 0);
    z-index: 100000;
    .video {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .video-close {
      position: absolute;
      width: 0.28rem;
      height: 0.28rem;
      left: 0.32rem;
      top: 0.16rem;
      z-index: 200000;
    }
    .btn-download {
      position: relative;
      padding: 0.05rem 0.3rem;
      border: 1px solid #fff;
      border-radius: 3px;
      color: #fff;
      top: 80vh;
    }
    #copy-input {
      position: absolute;
      left: 3000px;
    }
  }
}
</style>

